var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinSwitchOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27592 17.6462H17.7165C18.421 17.6462 19.008 16.6481 19.008 15.4152V2.75362C19.008 1.52073 18.4405 0.522705 17.7165 0.522705H2.27592C1.57141 0.522705 0.984375 1.52073 0.984375 2.75362V15.4152C0.984375 16.6481 1.57141 17.6462 2.27592 17.6462Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66348 14.9065C5.07444 15.7088 5.97474 15.9827 6.22915 14.241C6.54226 12.1471 6.18993 7.72435 6.26821 5.57168C6.36605 2.69493 6.44433 2.94934 5.40713 2.63622C3.90027 2.16655 4.64391 12.7734 4.66348 14.9065Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79433 14.9065C8.2053 15.7088 9.10548 15.9827 9.35989 14.241C9.673 12.1471 9.32079 7.72435 9.39907 5.57168C9.49691 2.69493 9.57519 2.94934 8.53799 2.63622C7.03113 2.16655 7.77476 12.7734 7.79433 14.9065Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8862 14.9065C11.2972 15.7088 12.1973 15.9827 12.4517 14.241C12.7649 12.1471 12.4125 7.72435 12.5104 5.57168C12.6082 2.69493 12.6865 2.94934 11.6493 2.63622C10.1425 2.16655 10.8861 12.7734 10.9057 14.9065H10.8862Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8217 14.9065C14.2326 15.7088 15.1328 15.9827 15.3872 14.241C15.7003 12.1471 15.348 7.72435 15.4263 5.57168C15.5241 2.69493 15.6025 2.94934 14.5653 2.63622C13.0585 2.16655 13.8021 12.7734 13.8217 14.9065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinSwitchOff);
export default __webpack_public_path__ + "static/media/spin-switch-off.5e2703e2c05dd8848992798f225e4280.svg";
export { ForwardRef as ReactComponent };